import styled from 'styled-components'
import { theme } from '../../../../styles/theme'

export const Container = styled.div`
  margin-top: 30px;
`

export const StandardItem = styled.div`
  width: 80%;
  height: 48px;
  padding: 13px;
  margin-bottom: 0px !important;

  display: flex;
  align-items: center;

  border-radius: ${theme.border.smallRadius};
  border: 1px solid #B9C1CB;
  box-shadow: 0px 3px 2px rgba(185, 193, 203, 0.22);
  background: ${theme.colors.white};
  font-size: ${theme.font.sizes.small};
  line-height: ${theme.font.sizes.normal};
  font-family: ${theme.font.montserrat};
  color: ${theme.colors.brown};
`

export const TrashButton = styled.button`
  width: 50px;
  height: 40px;
  max-width: 40px;
  max-height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 20px;
  border: 1px solid #FFCECE;
  background: ${theme.colors.mainBg};

  & path {
    fill: ${theme.colors.red};
  }
`

export const AdicionalButton = styled.button`
  height: 40px;
  padding: 14px;
  margin-top: 30px;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;

  background: ${theme.colors.blue};
  color: ${theme.colors.mainBg};
  border-radius: ${theme.border.smallRadius};
  font-weight: ${theme.font.normal};
  font-size: ${theme.font.sizes.xxsmall};
  line-height: ${theme.font.sizes.xsmall};

  transition: filter 300ms;

  & path {
    fill: ${theme.colors.mainBg};
  }

  &:hover {
    filter: brightness(0.8);
  }
`
